import { addTrustedForm, setTCPALanguage, initAnura } from '../common';
import { MP as greenMP } from '../themes/green';
import { MP as purpleMP } from '../themes/purple';
// import { goog_report_conversion } from '../common/pixels';

const schema = {
  email_address: {
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);

      // goog_report_conversion();

      if (window.sooper_panel.props.theme !== false) {
        window.sooper_panel.props.theme === 'green' ? greenMP() : purpleMP();
      }

      document.getElementById('labels').style.display = 'block';

      if (window.sooper_panel.wrapper.querySelectorAll('.blurb').length) {
        window.sooper_panel.wrapper
          .querySelectorAll('.blurb')
          .forEach(function (e) {
            e.remove();
          });
      }

      if (document.querySelector('.congrats-large.congrats')) {
        document.querySelector('.congrats-large.congrats').remove();
      }

      if (document.querySelector('.congrats-large.firstname')) {
        document.querySelector('.congrats-large.firstname').remove();
      }

      document.querySelector('.congrats-large').classList.add('lrg');

      if (document.querySelector('.congrats-large')) {
        document.querySelector('.congrats-large').classList.add('lrg');
      }

      document.getElementById('continue').innerHTML = 'NEXT';
      document.getElementById('continue').classList.remove('minSubBtn');

      if (document.getElementById('panel-wrapper').querySelector('h5')) {
        document
          .getElementById('panel-wrapper')
          .querySelector('h5')
          .classList.add('lrg');
      }

      if (
        window.sooper_panel.props.source.toLowerCase() ===
        'fbmanychatpromossweeps930'
      ) {
        var script = document.createElement('script');
        script.innerHTML = `!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '564454228329512');
        fbq('track', 'PageView');
        fbq('track', 'Lead');`;
        document.head.appendChild(script);

        var noscript = document.createElement('noscript'),
          img = document.createElement('img');

        img.setAttribute(
          'src',
          'https://www.facebook.com/tr?id=564454228329512&ev=PageView&noscript=1',
        );
        img.setAttribute('height', 1);
        img.setAttribute('width', 1);
        noscript.appendChild(img);
        document.head.appendChild(noscript);
      }

      initAnura(
        window.sooper_panel.props.visit_id,
        window.sooper_panel.props.anuranum,
        window.sooper_panel.props.anuraper,
      );
    },
  },
  first_name: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? "We need our next winner's name"
        : "We need our next winner's FIRST name.",
    // beforeSubmit: () => addTrustedForm(),
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  last_name: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Confirm your last name.'
        : 'Confirm your LAST name.',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  address_1: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Great! You qualify! Now if you win, where do we mail your $10,000 prize?'
        : 'If you win, where do we mail your $10,000 prize?',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  city: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'In what city do you reside?'
        : 'In what city do you reside?',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  state: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Select your state from the dropdown.'
        : 'Select your state from the dropdown.',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  zip_code: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Confirm we ship our $10,00 prize to your ZIP CODE.'
        : 'What is your zip code?',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  birth_month: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'In what month where you born?'
        : 'Are you old enough to enter? When were you born?',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  birth_day: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'On what day were you born?'
        : 'On what day were you born?',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  birth_year: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'Are you old enough to enter? When were you born?'
        : 'What year were you born?',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    },
  },
  gender: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? 'What is your gender?'
        : 'What is your gender?',
    afterSubmit: () => {
      setTimeout(function () {
        document.querySelector('body').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);

      // window.sooper_panel.certificate_url = document
      //   .getElementById('panel-wrapper')
      //   .getAttribute('data-certificate-url');

      window.sooper_panel.controller.continueBtn.innerHTML =
        "YOU'RE ALMOST THERE!";
      // window.sooper_panel.controller.continueBtn.parentNode.appendChild(
      //   setTCPALanguage(),
      // );
      window.sooper_panel.controller.continueBtn.classList.add('submit');
    },
  },
  phone_number: {
    title:
      parseInt(
        document
          .querySelector('[data-funnel-id]')
          .getAttribute('data-funnel-id'),
      ) === 99
        ? "We contact our winner by phone. What's the best number to reach you?"
        : "If you win, what's the best number to reach you?",
  },
};

export default class Creative {
  constructor() {
    Object.assign(this, schema);
  }
}
